export default function isValidDecimalNumber(value: string) {
  return value.match(/^[0-9]*\.?[0-9]*$/);
}
